import React, { useState, useRef,lazy, Suspense } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, getVerified, baseFake, getRemotedbUrl, getLayout, isNotEmpty } from '../lib/ep.js';
import { stage_categories, stage_promotion_types } from '../data/bootstrap_stages';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min.js';

import QuizClient from './QuizClient';

import ActionButton from '../components/builder/ActionButton.js';
import ActionLink from '../components/builder/ActionLink.js';
import ButtonCollection from '../components/builder/ButtonCollection.js';

import BracketClient from '../components/front/BracketClient';
import CrushClient from '../components/front/CrushClient.js';
import DirectParticipation from '../components/front/DirectParticipation';
import GuessWordClient from '../components/front/GuessWordClient.js';
import MediaParticipation from '../components/front/MediaParticipation';
import TriviaClient from '../components/front/TriviaClient';
import StoryStage from '../components/front/stages/StoryStage';

import SmashItClient from '../components/front/SmashItClient.js';
import StackItClient from '../components/front/StackItClient.js';
import CrosswordsClient from '../components/front/CrosswordsClient.js';
import PunchCardClient from '../components/front/PunchCardClient.js';
import StageFormClient from '../components/front/StageFormClient.js';
import CatchItClient from '../components/front/CatchItClient.js';

import LeveledHTMLText from '../components/front/helpers/LeveledHTMLText.js';
import PhotoFunStage from '../components/front/PhotoFunStage.js'

import QuizResultFlex from '../components/users/QuizResultFlex';
import EntriesMultiGallery from '../components/users/EntriesMultiGallery';

import RevealStage from './stages/RevealStage.js';
import RouletteStage from './stages/RouletteStage';
import ScratchStage from './stages/ScratchStage.js';
import StageRequirements from './stages/StageRequirements';
import TeamStage from './stages/TeamStage.js';
import Spinner from '../components/builder/Spinner.js';
import { localizeFields } from '../components/builder/DynamicFields.js';
import OneTimeBracketClient from '../components/front/OneTimeBracketClient.js';
//import WordSearchClient from '../components/front/WordSearchClient.js';
//import PuzzleClient from '../components/front/PuzzleClient.js';

const PuzzleClient = lazy(() => import('../components/front/PuzzleClient.js'));
const WordSearchClient = lazy(() => import('../components/front/WordSearchClient.js'));
const MemoryClient = lazy(() => import('../components/front/MemoryClient.js'));
const MatchItClient = lazy(() => import('../components/front/MatchItClient.js'));
const HiddenClient = lazy(() => import('../components/front/HiddenClient.js'));
const MineSweeperClient = lazy(() => import('../components/front/MineSweeperClient.js'));
const BattleClient = lazy(() => import('../components/front/BattleClient.js'));
const PickFavoriteClient = lazy(() => import('../components/front/PickFavoriteClient.js'));
const LikeDislikeClient = lazy(() => import('../components/front/LikeDislikeClient.js'));
const PenaltyClient = lazy(() => import('../components/front/PenaltyClient.js'));
const GuessScoreClient = lazy(() => import('../components/front/GuessScoreClient.js'));

const Loading = () => (
	<div>Loading...</div>
);

export const PremoderationActionMessage = ({stage,reset, ...props}) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const block_requirement_message = `<h2>${i18n("You have pending receipts under review")}</h2><p>${i18n("You've reached the maximum number of receipts in manual review. Once the reviews are completed, you'll be able to participate again. Thank you for your patience!")}</p>`;
	const default_premoderation_message = `<h2>${i18n("Thank you, we'll manually review the information provided as soon as possible.")}</h2><p>${i18n("We will let you know shortly if the receipt is valid.")}</p>`;
	const message_premoderate = stage?.reqs_premoderation_message ?? default_premoderation_message;
	const blocked_requirements = props?.block_requirement ?? false;
	const just_uploaded_ticket = props?.just_uploaded_ticket ?? false;

	//const previous_message_premoderate = (blocked_requirements) ? `${i18n("Pending review requests")}: ${props?.total_tickets_in_review ?? ''}` : false;

	return (
		<>	
			{/*(previous_message_premoderate) && (
				<div class="no_more_participations not_in_bottom">
					<div>
						<span class="icon knk-loading" />
						<p><strong>{previous_message_premoderate}</strong></p>
					</div>
				</div>
			)*/}
			{(blocked_requirements && !just_uploaded_ticket) && (
				<>
					<LeveledHTMLText>
						{block_requirement_message}
					</LeveledHTMLText>
					<ButtonCollection
						_class={{ other:'footer_actions gui_not_in_top_big' }}
					>	
						<ActionLink
							_href={(!props.is_builder) ? getRemotedbUrl(`/p/${stage.promotion_id}`) : null}
						>Home</ActionLink>
					</ButtonCollection>
				</>
			)}

			{(false) && (
				<ButtonCollection
					_class={{ other:'flex_button gui_big_button gui_flex_center gui_not_in_top_big' }}
					style={{ '--button-size':'25em' }}
				>
					<ActionButton
						onClick={() => reset(false)}
					>Upload another ticket</ActionButton>
				</ButtonCollection>
			)}
			
			{(!blocked_requirements || just_uploaded_ticket) && (
				<>	
					<LeveledHTMLText>
					{message_premoderate}
					</LeveledHTMLText>
					<ButtonCollection
						_class={{ other:'footer_actions gui_not_in_top_big' }}
					>	
						{(!blocked_requirements) && (
							<ActionLink
								_href={(!props.is_builder) ? getRemotedbUrl(`/promotions/participate/${stage.promotion_id}`) : null}
							>***Back</ActionLink>
						)}
					</ButtonCollection>
				</>
			)}
			
		</>
	)
}

export const getStageTitle = (stage) => {
	let stage_title = " #" + stage.id;
	if(stage.display_title != undefined && stage.display_title != "") stage_title = stage.display_title;
	return stage_title;
};

export const canParticipate = (timezone, participation, stage, is_builder) => {

	/*const open = (EPDateBefore(stage.start_date) && EPDateAfter(stage.end_date)) ? true : false;
	const closed = (EPDateBefore(stage.end_date)) ? true : false;
	const pending = (!open && !closed) ? true : false;*/

	const open = (moment.tz(stage.start_date, timezone).isBefore() && moment.tz(stage.end_date, timezone).isAfter()) ? true : false;
	const closed = (moment.tz(stage.end_date, timezone).isBefore()) ? true : false;
	const pending = (!open && !closed) ? true : false;

	const can_participate_again = ((participation == undefined || (participation.retries != undefined && participation.retries > 0)) || is_builder) ? true : false;

	return [ open, closed, pending, can_participate_again ];
};

const appendLT = () => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	if (urlParams.get('lt')) {
		return '?lt='+urlParams.get('lt');
	}
	return "";
}

const Stage = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ loading, setLoading ] = useState(false);
	const [ code, setCode ] = useState('');
	const [ ticket, setTicket ] = useState(props.ticket);
	const [ ticket_in_review, setTicketInReview ] = useState(false);
	const [ total_tickets_in_review, setTotalTicketsInReview ] = useState(props?.total_tickets_in_review ?? 0);
	const [ questions, setQuestions ] = useState(false);
	const [ response, setResponse ] = useState(false);
	const [ can_participate, setCanParticipate] = useState(true);
	const [ stats, setStats ] = useState({});

	const submitting = useRef(false);
	const num_participations = useRef(props.num ?? 1);
	const is_builder = window?.is_owner ?? false;
	const stage = props.stage.Stage;
	const stage_type = parseInt(props.stage.Stage.type);
	const promotion_id = props?.promotion?.Promotion?.id ?? false;
	const layout_props = getLayout(props?.promotion?.Promotion);

	const has_premoderation = stage?.reqs_premoderation ?? false;
	const stage_with_ticket_premoderation = (has_premoderation && (stage.reqs_type == 3 || (stage.reqs_type == 1 && isNotEmpty(stage,'reqs_graphic_info',[''])))) ? true : false;
	const default_review_tickets = parseInt(stage?.reqs_premoderation_inreview_tickets ?? 2);
	const block_requirement = (has_premoderation || stage.reqs_type == 8) && total_tickets_in_review >= default_review_tickets ? true : false;
	const history = useHistory();
	const codeValidate = (data, cb) => {
		$.post(getRemotedbUrl(`/promotions/prereq/${promotion_id}${appendLT()}`), {
			id:stage.id,
			...data,
		}, (response) => {
			history.replace(`${history.location.pathname}${appendLT()}`);
			if(cb != undefined) cb(response);
		}, 'JSON');
	};

	const getTicket = (cb) => {
		$.post(getRemotedbUrl(`/promotions/prereq/${promotion_id}${appendLT()}`), {
			id:stage.id,
		}, (response) => {
			ticketCallBack(response);
			if(cb != undefined) cb(response);
		}, 'JSON');
	};

	const change = (k, v) => {
		if(k == 'code') setCode(v);
	};

	const ticketCallBack = (response) => {
		if (response?.num) num_participations.current = response.num;
		if(response.in_review != undefined){
			setTicketInReview(response.in_review);
			if(response.in_review)setTotalTicketsInReview(total_tickets_in_review+1);
		}
		setTicket(response.ticket);
	}

	const validate = (data, cb) => {
		switch(stage.reqs_type) {
			case '1':
			case '3':
			case '5':
			case '6':
			case '7':
				codeValidate(data, (response) => {
					if(response.status == 1) {
						ticketCallBack(response);
						
						if (stage.reqs_type == '7') {
							window?.menu_ref?.getWrappedInstance().setTokens({[response?.loyalty.token_id]:response?.loyalty.total});
						}

						//setTicket(response.ticket);
						if(cb != undefined) cb(response);
					} else {
						if(cb != undefined) cb(response);
						if(response.url) {
							window.location.href = response.url;
						}
					}
				});
				break;

			case '4':
				codeValidate(data, (response) => {
					if(response.status == 1) {
						if(cb != undefined) cb(response, () => ticketCallBack(response));
					} else {
						if(cb != undefined) cb(response);
					}
				});
				break;
			case '8':
				
				if(data.status == 1) {
					ticketCallBack(data);
					if(cb != undefined) cb(data);
				} else {
					if(cb != undefined) cb(data);
				}
				
				break;
		}
	};

	const canPlayAgain = (cb) => {
		if(stage.reqs_type != undefined && stage.reqs_freq != undefined && stage.reqs_freq == 1) {
			setTicket(false);
			num_participations.current = 1;
			setCode('');
			setResponse(false);
			return;
		}

		if(stage.type == stage_categories.ID_TIMED_CATEGORY.id) {
			setQuestions(false);
		}

		if(cb != undefined) cb();
	};

	const handle_participate_errors = (response) => {
		if(response.status != 0) return false;

		if(response.reason == 'prize_closed') {
			window.location.href = getRemotedbUrl(`/promotions/not_allowed/${promotion_id}/no_more_prizes/${stage.id}`);
			return true;
		}
		window.location.href = getRemotedbUrl(`/promotions/not_allowed/${promotion_id}/no_valid`);
		return true;
		return false;
	};

	const submitBracket = (user, cb) => {
		$.post(getRemotedbUrl(`/promotions/participate/${promotion_id}/${stage.id}`), {
			user:baseFake(getVerified(JSON.parse(JSON.stringify(user)))),
			ticket,
		}, (res) => {
			if(cb !== undefined) cb(res);
		}, 'JSON');
	};

	const submitMedias = (user, cb) => {
		$.post(getRemotedbUrl(`/promotions/participate/${promotion_id}/${stage.id}`), {
			user:JSON.stringify(user),
			ticket,
		}, (res) => {
			if(cb !== undefined) cb(res);
		}, 'JSON');
	};

	const submitQuiz = (points, user, cb) => {
		$.post(getRemotedbUrl(`/promotions/participate/${promotion_id}/${stage.id}`), {
			points:points,
			user:baseFake(getVerified(JSON.parse(JSON.stringify(user)))),
			csrf:props.csrf,
			ticket,
		}, (res) => {
			if(handle_participate_errors(res)) return;
			if(res.next_participation != true) setCanParticipate(false);
			if(res.stats) setStats(res.stats);
			if(cb !== undefined) cb(res);
		}, 'JSON');
	};

	const submitTrivia = (points, user, cb, validate_response, time, gp, completed) => {
		$.post(getRemotedbUrl(`/promotions/participate/${promotion_id}/${stage.id}`), {
			points:points,
			user:baseFake(getVerified(JSON.parse(JSON.stringify({ user, points, hash:validate_response.hash, time, gp, completed})))),
			ticket,
		}, (res) => {
			if(handle_participate_errors(res)) return;
			if(cb !== undefined) cb(res);
		}, 'JSON');
	}

	const submitQuizParticipation = (points, user, cb) => {
		setLoading(true);
		submitting.current = true;
		submitQuiz(points, user, (res) => {
			setLoading(false);

			if(res?.loyalty != undefined){
				res.loyalty.token = window.loyalty_tokens.tokens[res?.loyalty.token_id]
				window?.menu_ref?.getWrappedInstance().setTokens({[res?.loyalty.token_id]:res?.loyalty.total});
			}

			setResponse(res);
		});
	};

	const participate = (cb) => {
		$.post(getRemotedbUrl(`/promotions/participate/${promotion_id}/${stage.id}${appendLT()}`), {
			ticket,
		}, (res) => {
			if(res.status) {
				window.location.href = res.url;
			}
		}, 'JSON');
	};

	const participateStamp = (cb) => {
		$.post(getRemotedbUrl(`/promotions/participate/${promotion_id}/${stage.id}`), {
			ticket,
		}, (res) => {
			if (cb != undefined) cb(res);
		}, 'JSON');
	};

	const participateCustomCallback = (url) => {
		$.post(getRemotedbUrl(`/promotions/participate/${promotion_id}/${stage.id}`), {
			ticket,
		}, (res) => {
			if(res.status) {
				window.location.href = (url != undefined) ? url : res.url;
			}
		}, 'JSON');
	};

	const getTrivia = () => {
		$.get(getRemotedbUrl(`/promotions/gettrivia/${promotion_id}/${stage.id}`), (string) => {
			let data = JSON.parse(atob(string));
			setQuestions(data);
		});
	};

	if(isNaN(stage_type)) {
		return (
			<div>{i18n("Wrong stage type.")}</div>
		)
	}

	if(loading) {
		return (
			<section class="mod_align_center gui_full_container main_contents_flex">
				<article id="success_contents" class="success_container gui_semi_container">
					<article class="success_status">
						<div class="thankyou_message">
							<Spinner
								color='rgba(var(--p-color))'
								_class={{ other:'is_transparent gui_pos_rel_important'}}
							>You are being redirected. Please, wait.</Spinner>
						</div>
					</article>
				</article>
			</section>
		)
	}

	//Prereq stage
	if(stage.reqs_type != undefined && stage.reqs_type != 0 && !ticket && !block_requirement) {
		return (
			<StageRequirements
				change={change}
				locale={props.locale}
				vars={props.vars}//per retornar codi qr dinamic valid
				promotion={props.promotion.Promotion}
				validate={validate}
				continue={getTicket}
				stage={stage}
				stages={props.stages}
				participations={props.participations}
				loyalty={props.loyalty}
				remaining_ocr={props.remaining_ocr}
				ocr_ticket={props.ocr_ticket}
				notification_email={props.notification_email}
			/>
		)
	}

	//Upload Receipt OR Validate Code with image + premoderation
	if((ticket_in_review && stage_with_ticket_premoderation) || block_requirement){
		return (
			<PremoderationActionMessage 
				stage={stage}
				reset={setTicket}
				is_builder={is_builder}
				total_tickets_in_review={total_tickets_in_review}
				block_requirement={block_requirement}
				just_uploaded_ticket = {ticket_in_review ? true : false}
				intl={props.intl}
			/>
		)
	}

	if(stage_type == stage_categories.ID_FORM_CATEGORY.id) {
		return (
			<DirectParticipation
				{...props}
				participate={participate}
				ticket={ticket}
			/>
		)
	}

	if(stage_type == stage_categories.ID_QUIZ_CATEGORY.id) {
		if(response) {
			if(response.qr == undefined) {
				setTimeout(() => {
					window.location.href = response.url;
				}, 500);

				return (
					<section class="mod_align_center gui_full_container main_contents_flex">
						<article id="success_contents" class="success_container gui_semi_container">
							<article class="success_status">
								<div class="thankyou_message">
									<Spinner
										color='rgba(var(--p-color))'
										_class={{ other:'is_transparent gui_pos_rel_important'}}
									>You are being redirected. Please, wait.</Spinner>
								</div>
							</article>
						</article>
					</section>
				);
			}
			
			if (props.promotion.Promotion?.one_step_login || props.promotion.Promotion?.login_type == 4) {
				window.location.href = response.url;
				return;
			}

			return (
				<QuizResultFlex
					promotion={props.promotion.Promotion}
					stage={stage}
					is_builder={is_builder}
					response={response}
					locale={props.locale}
					play_again={(e, cb) => canPlayAgain(() => { cb(); setResponse(false); submitting.current = false; })}
				/>
			)
		}

		if(submitting.current) return null;

		return (
			<QuizClient
				store={props.store}
				stage={props.stage}
				is_game={false}
				questions={props.questions}
				promotion={props.promotion}
				gp_hash={props.gp_hash}
				submitQuiz={submitQuizParticipation}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				progress_type={stage.quiz_progress_type}
				enable_change={stage.quiz_enable_change}
				locale={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_GAME_CATEGORY.id) {
		const client_props = {
			stage:props.stage,
			submitQuiz,
			canPlayAgain,
			gp_hash:props.gp_hash,
			promotion:props.promotion,
			locale:props.locale
		}

		let GameComponent;

		switch(parseInt(props.stage.Stage.promotion_type_id)) {
			case stage_promotion_types.PUZZLE_NEW.id:
				GameComponent = PuzzleClient;
				break;

			case stage_promotion_types.WORDSEARCH_NEW.id:
				GameComponent = WordSearchClient;
				break;

			case stage_promotion_types.MEMORY_NEW.id:
				GameComponent = MemoryClient;
				break;

			case stage_promotion_types.MATCH_IT_NEW.id:
				GameComponent = MatchItClient;
				break;

			case stage_promotion_types.HIDDEN_OBJECTS_NEW.id:
				GameComponent = HiddenClient;
				break;

			case stage_promotion_types.MINESWEEPER_NEW.id:
				GameComponent = MineSweeperClient;
				break;

			case stage_promotion_types.FACEOFF.id:
				GameComponent = BattleClient;
				client_props.stats = stats;
				client_props.stage.Stage.faceoff_players = localizeFields(client_props.stage.Stage.faceoff_players ?? [],props.locale);
				break;

			case stage_promotion_types.PICK_FAVORITE.id:
				GameComponent = PickFavoriteClient;
				client_props.stats = stats;
				break;

			case stage_promotion_types.LIKEDISLIKE.id:
				GameComponent = LikeDislikeClient;
				client_props.stats = stats;
				break;

			case stage_promotion_types.PENALTY.id:
				GameComponent = PenaltyClient;
				client_props.stats = stats;
				break;

			case stage_promotion_types.SCORE_PREDICTOR.id:
				GameComponent = GuessScoreClient;
				client_props.stats = stats;
				break;

			case stage_promotion_types.BRACKET_PREDICTOR.id:
				GameComponent = OneTimeBracketClient;
				client_props.stats = stats;
				break;
		}

		if(GameComponent) {
			return (
				<Suspense fallback={<Loading />}>
					<GameComponent
						{...client_props}
					/>
				</Suspense>
			);
		}
 
		return (
			<QuizClient
				store={props.store}
				stage={props.stage}
				is_game={true}
				questions={props.questions}
				promotion={props.promotion}
				gp_hash={props.gp_hash}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_MEDIA_CATEGORY.id) {
		return (
			<MediaParticipation
				is_game={false}
				stage={props.stage}
				questions={props.questions}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				submitMedias={submitMedias}
				canPlayAgain={canPlayAgain}
				multiparticipation={false}
				brackets={props.brackets}
				locale={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_VOTING_CATEGORY.id) {
		return (
			<EntriesMultiGallery
				stage={props.stage.Stage}
				promotion={props.promotion.Promotion}
				base_route="/promotions/participate/"
				votingSubmit={submitQuiz}
				avail_participations={can_participate ? {} : {next_participation:false}}	// we pass an empty object, so it considers it will have new participations available (we are in participate, so the verfication was already done in stageMosaic)
				is_logged={true}	// we assume user is logged in since we're in participate (after login form page)
				locale={props.locale}
				participate_error={props.participate_error}
			/>
		)
	}

	if(stage_type == stage_categories.ID_ROULETTE_CATEGORY.id) {
		return (
			<RouletteStage
				{...props}
				canPlayAgain={canPlayAgain}
				ticket={ticket}
			/>
		)
	}

	if(stage_type == stage_categories.ID_TIMED_CATEGORY.id) {
		if(!questions) {
			getTrivia();

			return (
				<div>Loading...</div>
			)
		}

		return (
			<TriviaClient
				is_game={true}
				stage={props.stage}
				questions={questions}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				main_color={layout_props.color.main_color}
				submitQuiz={submitTrivia}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale ={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_BRACKET_CATEGORY.id) {
		return (
			<BracketClient
				is_game={false}
				stage={props.stage}
				questions={props.questions}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				submitQuiz={submitBracket}
				canPlayAgain={canPlayAgain}
				multiparticipation={false}
				brackets={props.brackets}
			/>
		)
	}

	if(stage_type == stage_categories.ID_CRUSH_CATEGORY.id) {
		return (
			<CrushClient
				is_game={false}
				stage={props.stage}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale ={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_SMASHIT_CATEGORY.id) {
		return (
			<SmashItClient
				is_game={false}
				stage={props.stage}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale ={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_STACKIT_CATEGORY.id) {
		return (
			<StackItClient
				is_game={false}
				stage={props.stage}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale ={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_CROSSWORDS_CATEGORY.id) {
		return (
			<CrosswordsClient
				is_game={false}
				stage={props.stage}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
			/>
		)
	}

	if(stage_type == stage_categories.ID_CATCHIT_CATEGORY.id) {
		return (
			<CatchItClient
				is_game={false}
				stage={props.stage}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_STAGE_FORM.id) {
		return (
			<StageFormClient
				field_config={{
					signature:{
						auto_url:`/users/upload/${props.stage.Stage.promotion_id}`,
						auto_type:"entries_form"
					}
				}}
				is_game={false}
				stage={props.stage}
				gp_hash={props.gp_hash}
				promotion={props.promotion.Promotion}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_GUESSWORD_CATEGORY.id) {
		return (
			<GuessWordClient
				is_game={false}
				stage={props.stage}
				promotion={props.promotion.Promotion}
				gp_hash={props.gp_hash}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale ={props.locale}
			/>
		)
	}

	if(stage_type == stage_categories.ID_STAMPSCARD_CATEGORY.id) {
		
		return (
			<PunchCardClient
				participations={props.participations}
				participate={participateStamp}
				coming_stamps={num_participations.current}
				is_game={false}
				stage={props.stage}
				promotion={props.promotion.Promotion}
				gp_hash={props.gp_hash}
				submitQuiz={submitQuiz}
				canPlayAgain={canPlayAgain}
				multiparticipation={true}
				locale ={props.locale}
				prizes={props.prizes}
			/>
		)
	}

	if(stage_type == stage_categories.ID_STORY_CATEGORY.id) {
		return (
			<StoryStage
				stage={props.stage.Stage}
				participate={participateCustomCallback}
				ticket={ticket}
			/>
		)
	}

	if(stage_type == stage_categories.ID_REVEAL_CATEGORY.id) {
		return (
			<ScratchStage
				{...props}
				canPlayAgain={canPlayAgain}
				ticket={ticket}
			/>
		)
	}

	if(stage_type == stage_categories.ID_TEAM_CATEGORY.id) {
		return (
			<TeamStage
				{...props}
				canPlayAgain={canPlayAgain}
				ticket={ticket}
			/>
		)
	}

	if(stage_type == stage_categories.ID_REVEAL_WIN_CATEGORY.id) {
		return (
			<RevealStage
				{...props}
				canPlayAgain={canPlayAgain}
				ticket={ticket}
			/>
		)
	}

	if(stage_type == stage_categories.ID_PHOTO_FUN.id) {
		return (
			<PhotoFunStage
				{...props}
				onFinish={(user, cb) => {
					submitMedias(user, (res) => {
						if(res.status) {
							// if(res.next_participation != undefined) {
							// 	var next_participation = res.next_participation;
							// 	if(next_participation !== false && next_participation !== true) {
							// 		var time_to_next_participation = EPDateDuration(EPDateDiff(next_participation));
							// 		res.next_participation = EPDateHumanize(time_to_next_participation);
							// 	} else {
							// 		res.next_participation = next_participation;
							// 	}
							// }

							if(res.status && cb != undefined) {
								cb(res);
							}
							/*if(res.status && res.url) {
								window.location.href = res.url;
								return;
							}*/
						}
					});
					// submitMedias({
					// 	photo_fun:{
					// 		image,
					// 		meta
					// 	}
					// })
				}}
				canPlayAgain={canPlayAgain}
			/>
		)
	}

	return (
		<div>{i18n("This kind of stage is not defined yet!")}</div>
	);
}

export default injectIntl(Stage);